// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"ec06f21b","911":"1f90d2f8"}[chunkId] + ".chunk.css";
};